import { useState } from 'react';

import styled from 'styled-components';

import { PAGES } from '../../constants/pages';

import { Header, HeaderTitle } from 'components/Header';
import { PageTitle } from 'components/PageTitle';
import { Card, CardContent } from 'components/ui/card';
import { MicrostoreColumnSelect } from 'components/Select/MicrostoreColumnSelect';
import { ExpiryDateRecordList } from './ExpiryDateRecordList';

export const ExpiryDateRecords = () => {
    const [selectedColumnId, setSelectedColumnId] = useState<string | null>(null);

    return (
        <Container>
            <Header>
                <HeaderTitle>
                    <PageTitle page={PAGES.expiryDateRecords} />
                </HeaderTitle>
            </Header>
            <Content>
                <Card className="bg-white">
                    <CardContent className="flex flex-col gap-4">
                        <MicrostoreColumnSelect
                            value={selectedColumnId}
                            onChange={setSelectedColumnId}
                            label="Colonne"
                            dataTest="expiry-date-column-select"
                        />

                        {selectedColumnId ? <ExpiryDateRecordList columnId={selectedColumnId} /> : null}
                    </CardContent>
                </Card>
            </Content>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 100%;
    background-color: ${({ theme }) => theme.backgroundColor};
`;

const Content = styled.div`
    display: flex;
    flex-direction: column;
    padding: 15px;
    flex: 1;
    overflow: hidden;

    & > :not(:first-child) {
        margin-top: 15px;
    }
`;
